import { ProfileAvatar } from '@care/react-component-lib';
import { useResponsive } from '@/components/hooks/useResponsive';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/seoSegmentationListingPage';
import { getUserInitials } from '@/utils/getUserInitials';

export interface CaregiverProfileAvatarProps {
  caregiver: Caregiver;
  isClientSearchResultsQuery: boolean;
}

export const CaregiverProfileAvatar = ({
  caregiver,
  isClientSearchResultsQuery,
}: CaregiverProfileAvatarProps) => {
  const { isSmallViewport } = useResponsive();

  const profileAvatarProps = {
    alt: `${caregiver.member.displayName}'s Photo`,
    size: isSmallViewport ? 'xLarge' : 'squareLarge',
    src: caregiver.member.imageURL ?? undefined,
    slotProps: {
      avatar: {
        imgProps: isClientSearchResultsQuery
          ? { loading: 'eager' as const }
          : { loading: 'lazy' as const },
      },
    },
  } as const;

  return (
    <ProfileAvatar {...profileAvatarProps}>
      {getUserInitials(caregiver.member.displayName)}
    </ProfileAvatar>
  );
};
